import { useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import CustomDropDownMenu from "../../common/CustomDropDownMenu";
import { GetImages } from "../../../utils/GetImages";
import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";
import AddButtonWithArrow from "../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { Offcanvas } from "react-bootstrap";
import DescriptionTextarea from "../../../newComponents/form-fields/DescriptionTextarea";
import LeftArrowTopHeader from "../../../newComponents/form-fields/LeftArrowTopHeader";
import ActionMenu from "../../../newComponents/actionMenus/action-menu";
import { useNavigate } from "react-router";
import { TextCss } from "../../GlobalCss/TextCss";
import { usePermissions } from "../../../hooks/usePermissions";
import { TEMPLATE_TEXT_MAX_LENGTH, templateTextLimitMessage } from "./templateTextLimits";

const DESCRIPTION_LABEL = "Template Description";

type DescriptionFormValues = { description: string };

const QuestionHeader = ({ postData, setPostData, duplicateTemplete, deleteTemplete, previewApplication = false, handleSubmit = () => { }, isLoading = false }) => {
 const navigate = useNavigate()
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState(postData);

  const methods = useForm<DescriptionFormValues>({
    mode: "onChange",
    defaultValues: { description: postData?.description || "" },
  });

  const check = usePermissions();
  const canWrite = check.canWrite("Templates");

  const handleSave = (values: DescriptionFormValues) => {
    setShow(false);
    setPostData({ ...editData, description: values.description });
  };

  const handleEditClick = () => {
    setEditData({ ...postData });
    methods.reset({ description: postData?.description || "" });
    setShow(true);
  };

  const handleCancel = () => {
    setShow(false);
  };

  
  const menuItems = [
  {
    label: "Duplicate",
    icon: GetImages.BlackCopy,
    action: () => duplicateTemplete(),
  },
  { isDivider: true },
  {
    label: "Edit",
    icon: GetImages.BlackPencil,
    action: () => handleEditClick(),
  },
  { isDivider: true },
  {
    label: "Delete",
    icon: postData?.isInUse ? GetImages.greyDelete : GetImages.BlackDelete,
    action: () => deleteTemplete(),
    textClass: postData?.isInUse ? "sub_text fw-600 grey" : "sub_text fw-600 red",
  },
];

  return (
    <>
      <div className="application-top-card">
         <div className="flexRow align-items-center justify-content-center gap-2 ">
          <LeftArrowTopHeader className={TextCss.black.heading_700_16} title={isLoading ? "Loading..." : `${postData?.name}`} backPath={-1} />
            <p className="green">{!isLoading && postData?.isInUse ? "In use" : ""}</p>
          </div>
        {canWrite && !isLoading && (
          <ActionMenu
          menuItems={menuItems}
                trigger={
                  <button   
                  className="action-button" aria-label="More options">
                    <img
                      src={GetImages.dropdownIcon}
                      alt="More options"
                      width={20}
                      height={20}
                      className="action-icon"
                    />
                  </button>
                }
              />
        )}
        {/* <CustomDropDownMenu Action={true} Element={<img src={GetImages.BlueChevronDown} alt="BlueChevronDown" />} data={data} /> */}
      </div>

      <Offcanvas className="offcanvas serviceRequestForm" show={show} onHide={handleCancel} placement="end" scroll={true}>
        <Offcanvas.Header className="canvasHeader" closeButton>
          <Offcanvas.Title>Edit Template</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <FormProvider {...methods}>
            <form className="editbasicdetails needs-validation" onSubmit={methods.handleSubmit(handleSave)}>
              <div className="flexColumn p-3 gap-4">
                <CustomInputs
                  name="name"
                  type={FORM_CONTROLFIELD_TYPES?.TEXT}
                  value={editData?.name}
                  labelText="Template Name"
                  isFormControl
                  required
                  onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                  width="440px"
                />
                <DescriptionTextarea
                  name="description"
                  label={DESCRIPTION_LABEL}
                  placeholder="Add Template Description here..."
                  required
                  rows={5}
                  className="w-100"
                  alignCounterWithError
                  validation={{
                    maxLength: {
                      value: TEMPLATE_TEXT_MAX_LENGTH,
                      message: templateTextLimitMessage(DESCRIPTION_LABEL),
                    },
                  }}
                />
              </div>
              <div className="editFormFooter start-0">
                <AddTraspButton type="button" bname="Cancel" onClick={handleCancel} border={false} width="fit-content" />
                <AddButtonWithArrow buttonname="Save" type="submit" minWidth="100px" />
              </div>
            </form>
          </FormProvider>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default QuestionHeader;
